import useDC from '@eneco/dc/useDC';
import { type Products_Offers_V3_OfferProductCombinationResponseModel } from '@monorepo-types/dc';
import { usePlaceholderContent } from '@sitecore/common';
import { type Fields } from '@sitecore/types/OfferStep';
import { OfferStepRendering } from '@sitecore/types/OfferStep';

import { useCachedOfferMachine } from '.';
import { BLEND_AND_EXTEND_DISCOUNT_TYPES } from '../../eneco/helpers/constants';

export const useBlendAndExtendLogic = () => {
  const { businessUnit, label } = useDC();
  const { offerState } = useCachedOfferMachine(businessUnit, label);
  const offer = offerState?.context?.offer;

  const placeholderContent = usePlaceholderContent<{ OfferStep: OfferStepRendering }>();
  const { OfferStep: { fields: textualData } = {} } = placeholderContent;

  const isBlendAndExtend =
    offer?.productCombinations?.some((product: Products_Offers_V3_OfferProductCombinationResponseModel) =>
      BLEND_AND_EXTEND_DISCOUNT_TYPES.includes(product.discountType),
    ) ?? false;

  const blendAndExtendStepHeaderTextualData: Fields | undefined = textualData
    ? {
        ...textualData,
        content: {
          ...textualData.content,
          // TODO: Move it to sitecore step
          text: { value: 'Je hoeft niet te wachten tot je contract afloopt. Zet nu een lager leveringstarief vast.' },
        },
      }
    : undefined;

  return {
    isBlendAndExtend,
    blendAndExtendStepHeaderTextualData,
  };
};
